import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=388d1492&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=388d1492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d1492",
  null
  
)

export default component.exports